import React from "react";
import "./advisory1.css";

const Advisory2 = ({ image, title }) => {
  return (
    <div className=" text-center d-flex flex-column align-items-center">
      <img src={image} className="card-img mt-2" alt={title} />
    </div>
  );
};

export default Advisory2;
